// @ts-nocheck
import { Box } from '@mui/material';

import { FCheckbox, FProgressBar } from '../../../../../../components/base';
import { INSURANCE_TYPES } from '../../../../../../constants';
import { QuestionnaireSectionLabel } from '../../../../common';
import { useFormReadOnly } from '../../../../../common';
import { useOnboardingQuestionnaireLoading } from '../../../hooks';
import { INSURANCE_TYPE_TITLES } from '../insurance/constants';
import InsuranceForm from '../insurance';
import { NoSecondaryInsuranceConfirmModal } from './components';
import { useSecondaryInsuranceToggle } from './hooks';
import { READ_ONLY_CHECKBOX_SX } from './styles';
import { FORTA_BLUE } from '../../../../../../utils/colors';

export default function SecondaryInsuranceForm() {
  const isLoading = useOnboardingQuestionnaireLoading();
  const isReadOnly = useFormReadOnly();
  const { checked, isProcessing, isConfirmOpen, onCheckboxChange, onConfirm, onCancel } =
    useSecondaryInsuranceToggle();

  return (
    <>
      <QuestionnaireSectionLabel variant="h5" sx={{ mb: 1.5, color: FORTA_BLUE.primary }}>
        {INSURANCE_TYPE_TITLES[INSURANCE_TYPES.SECONDARY]}
      </QuestionnaireSectionLabel>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {isProcessing ? <FProgressBar /> : null}
        <FCheckbox
          label="Client has NO secondary insurance"
          checked={checked}
          disabled={isLoading || isProcessing || isReadOnly}
          onChange={onCheckboxChange}
          sx={isReadOnly ? READ_ONLY_CHECKBOX_SX : undefined}
        />
        {checked ? null : (
          <InsuranceForm insuranceType={INSURANCE_TYPES.SECONDARY} showTitle={false} />
        )}
      </Box>
      <NoSecondaryInsuranceConfirmModal
        open={isConfirmOpen}
        submitLoading={isProcessing}
        onClose={onCancel}
        onSubmit={onConfirm}
      />
    </>
  );
}
